/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Prop_P2Inputs */

const es_cap_prop_p2 = /** @type {(inputs: Cap_Prop_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La aceptas con un toque o la rechazas sin dar explicaciones. Tu agenda y tus criterios mandan, siempre.`)
};

const gl_cap_prop_p2 = /** @type {(inputs: Cap_Prop_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptas cun toque ou rexeitas sen dar explicacións. A túa axenda e os teus criterios mandan, sempre.`)
};

const en_cap_prop_p2 = /** @type {(inputs: Cap_Prop_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept with a tap or decline with no explanation. Your schedule and your rules, always.`)
};

/**
* | output |
* | --- |
* | "Accept with a tap or decline with no explanation. Your schedule and your rules, always." |
*
* @param {Cap_Prop_P2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_prop_p2 = /** @type {((inputs?: Cap_Prop_P2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Prop_P2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_prop_p2(inputs)
	if (locale === "en") return en_cap_prop_p2(inputs)
	return es_cap_prop_p2(inputs)
});